import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};


class POSAddTipAmountDialog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render(){
        const { t } = this.props;
        const p = this.props;
        return (
            <div>
                <DialogInput
                    title={<DialogHeader title={t('pos.addTipAmountDialog.tipTitle', { orderId: p.orderId})} />}
                    modal={true}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    actions={[
                        <Button
                            key={2}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.props.onClose()} />,
                        <Button
                            key={1}
                            name="addButton"
                            label={t('common.apply')}
                            primary={true}
                            onTouchTap={() => this.props.addTipAmount()} />
                    ]}>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <DecimalInput name={`${p.name}Value`}
                                    fullWidth={true}
                                    label={t('pos.addTipAmountDialog.tipAmount')}
                                    floatingLabelText={t('pos.addTipAmountDialog.tipAmount')}
                                    hintText={t('pos.addTipAmountDialog.tipAmount')}
                                    min={0}
                                    />
                            </div>
                        </div>
                </DialogInput>
            </div>
        )
    }
}

export default withTranslation()(POSAddTipAmountDialog);
